/**
 * Homepage product carousels: every ul[data-home-carousel] scrolls sideways (CSS scroll-snap in templates/index.liquid).
 * This adds previous/next arrow buttons (shown from tablet up) and keeps them disabled at either end. RTL-aware.
 */



function setup(list) {
  if (list.dataset.carouselReady) return;
  list.dataset.carouselReady = 'true';
  const wrap = document.createElement('div');
  wrap.className = 'home-carousel-wrap';
  list.parentNode.insertBefore(wrap, list);
  wrap.appendChild(list);

  const prevLabel = list.dataset.prev || 'Previous';
  const nextLabel = list.dataset.next || 'Next';
  const rtl = getComputedStyle(list).direction === 'rtl';
  const make = (cls, label, dir) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = `home-carousel-btn ${cls}`;
    b.setAttribute('aria-label', label);
    b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
    b.addEventListener('click', () => {
      const amount = list.clientWidth * 0.8 * dir * (rtl ? -1 : 1);
      list.scrollBy({ left: amount, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    wrap.appendChild(b);
    return b;
  };
  const prev = make('home-carousel-prev', prevLabel, -1);
  const next = make('home-carousel-next', nextLabel, 1);

  const update = () => {
    const max = list.scrollWidth - list.clientWidth;
    const pos = Math.abs(list.scrollLeft);
    prev.disabled = pos <= 2;
    next.disabled = pos >= max - 2;
    wrap.toggleAttribute('data-static', max <= 2);
  };
  list.addEventListener('scroll', update, { passive: true });
  new ResizeObserver(update).observe(list);
  update();
}

document.querySelectorAll('[data-home-carousel]').forEach(setup);
